<template>
  <div class="userBind">
    <div>
      <el-transfer
        :titles="['未授权角色', '已授权角色']"
        v-model="bindedRoles"
        :data="unbindRoles"
        :props="{
          key: 'id',
          label: 'name'
        }"
        filterable
      >
        <span slot-scope="{ option }" @click="getUser(option)">
          <el-popover placement="top-start" width="200" trigger="hover">
            <span>{{ option.description }}</span>
            <el-button slot="reference" type="text" style="color:#333">{{ option.name }}</el-button>
          </el-popover>
        </span>
      </el-transfer>
      <div style="padding-top: 10px; text-align: center">
        <el-button style="width: 150px" type="primary" @click="save" size="mini">确认</el-button>
        <el-button style="width: 150px" type="danger" @click="close()" size="mini">关闭</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import httpKit from '../../../../dxrj.sdk/js/kit/httpKit';
import {mapState} from "vuex";
export default {
  props: {
    params: Object
  },
  data() {
    return {
      unbindRoles: [],
      bindedRoles: [],
      id: '',
      unbind: '',
      binded: '',
      list: [],
      array: [],
      isTorole: false,
      isRole: {}
    };
  },
  computed: {
    userInfo: {
      get() {
        return this.$store.state.userInfo;
      },
      set(value) {
        this.$store.commit('setUser', value);
      }
    },
  },
  mounted() {
    this.ary();
    this.searchbyRole();
  },
  methods: {
    getUser(val) {
      this.bindedRoles.map(item => {
        if(val.id === item){
          this.isRole = val;
          this.userInfo = val;
          this.isTorole = true
        }
      });
      if(this.isTorole){
        this.$router.push({ path: '/eap_role_index' })
      }
    },
    close() {
      this.$emit('close');
    },
    save() {
      let par = {
        roleIds: this.bindedRoles ? this.bindedRoles.join() : [],
        userId: this.params.id
      };
      // ('授权中，请稍后');
      httpKit.post($api_eap.role.bindRole, par).then(res => {
        if (res.data.code === '200') {
          this.$message.success(res.data.msg);
          // .close();
          this.$emit('success');
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    searchbyRole() {
      let par = {
        userId: this.params.id,
        pageNo: 1,
        pageSize: 100000
      };
      httpKit.post($api_eap.role.searchbyRole, par).then(res => {
        if (res.data.code === '200') {
          this.bindedRoles = res.data.data;
          let arr = [];
          this.bindedRoles.forEach(item => {
            arr.push(item.id);
          });
          this.bindedRoles = arr;
        }
      });
    },
    ary() {
      let par = {
        pageNo: 1,
        pageSize: 100000
      };
      httpKit.post($api_eap.role.search, par).then(res => {
        if (res.data.code === '200') {
          this.unbindRoles = res.data.data;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.userBind /deep/.el-transfer-panel__list {
  height: 353px !important;
}
.userBind /deep/.el-transfer-panel__body {
  height: 400px !important;
}
.userBind /deep/.el-transfer-panel {
  width: 300px !important;
}
.userBind /deep/.el-transfer-panel__item .el-checkbox__input {
  top: 13px;
}
</style>
